const regExp = /^((?!\.)[\w-_.+]*[^.])(@\w+)(.\w+(.\w+)?[^.\W])$/;

export function checkEmail(email: string): boolean {
  return regExp.test(email);
}

export function getFirstPart(email: string): string {
  let r = regExp.exec(email);
  return r ? r[1] : "";
}
